export default [
  {
    name: "hotelSerch",
    path: "hotelSerch",
    component: () => import("@/components/hotel/HotelSearch"),
  },
  {
    name: "tourSerch",
    path: "tourSerch",
    component: () => import("@/components/tour/Search"),
  },
 

];
